import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { GeneralService } from "src/app/services/general.service";
import { EmailNotificationService } from "src/app/services/settings-services/email-notification.service";
import { FacebookService } from "src/app/services/social/facebook.service";
import { TwitterService } from "src/app/services/social/twitter.service";

import FacebookHandler from "./facebook";
import TwitterHandler from "./twitter";

@Component({
  selector: "app-social-feed",
  templateUrl: "./social-feed.component.html",
  styleUrls: ["./social-feed.component.css"],
})
export class SocialFeedComponent implements OnInit {
  private socket: any;
  feedItems: Array<any> = [];

  /** */
  facebook: any;
  twitter: any;

  /** */
  isFacebook: boolean = false;
  facebookActivePage: any = {};
  facebookFeed: any;
  handles: any;
  hashtags: any;
  stream_data: any = {
      hashtags: [],
      handles: [],
    };
  selectedOption: string = '1';
  facebookAnalyticsComment: any;
  facebookAnalyticsReactions: any;

  constructor(
    private commsNotification: EmailNotificationService,
    private facebookService: FacebookService,
    private twitterService: TwitterService,
    private toaster: ToastrService,
    private generalSrv: GeneralService,
  ) {

    
    this.facebook = new FacebookHandler(this.facebookService);
    this.twitter = new TwitterHandler(this.twitterService);


  }

  ngOnInit() {
    this.socket = this.commsNotification.get_socket();
    this.socket.on("new_tweet", (tweet) => {
      const parsedTweet = this.twitter.parseTweet(tweet);
      this.feedItems.unshift(parsedTweet);
    });

    this.socket.on("facebook_update", (data) => {

      this.processNewFeeds(this.facebookActivePage.id);
      this.getFacebookPageAnalytics(this.facebookActivePage.id)

    });

    // emission because of distributed nature of agents
    this.socket.on("tweet:handled", (id: number) => {
      this.twitterService.replied_tweet(id);
      this.facebookService.repliedPost(id);
    });

    // this.socket.on('email:new', data => {
    //   this.emailService.new_email.next(data)
    // });

    this.getOrganizationFacebookPage();
    this.getTwitterStreamSettings();
  }

  getOrganizationFacebookPage() {
    this.facebookService.fetchOrganizationPages().subscribe(
      (response: any) => {
        const { status_code, success, payload } = response;
        if (success && (status_code == 200 || status_code == 201)) {
          this.facebookActivePage = payload.active_page;
          this.getFacebookPagePosts(this.facebookActivePage.id);
          this.getFacebookPageAnalytics(this.facebookActivePage.id);
        } else {
          this.toaster.error(
            "Connect a Facebook page in the Ticket Inbound Comms settings page."
          );
        }
      },
      (e) => {
        this.toaster.error(
          "Connect a Facebook page in the Ticket Inbound Comms settings page."
        );
      }
    );
  }

  getFacebookPagePosts(pageId: number) {
    this.facebookService.fetchOrganizationPagePosts(pageId).subscribe(
      (response: any) => {
        const { status_code, success, payload } = response;
        if (success && (status_code == 200 || status_code == 201)) {
          this.feedItems.push(...payload);
        }
      },
      (e) => {
        this.toaster.error("Cannot find feed for your page.");
      }
    );
  }

  getFacebookPageAnalytics(pageId: number) {
    this.facebookService.fetchOrganizationPageAnalytics(pageId).subscribe(
      (response: any) => {
        const { status_code, success, payload } = response;
        if (success && (status_code == 200 || status_code == 201)) {
          this.facebookAnalyticsComment = payload.comment;
          this.facebookAnalyticsReactions = payload.reactions;

        }
      },
      (e) => {
        this.toaster.error("Cannot find feed analytics for your page.");
      }
    );
  }

  getTwitterStreamSettings() {
    this.twitterService.fetch_stream_setting().subscribe((response: any) => {
      if (response.success) {
          this.twitter.set_twitter_settings(response.payload);
          this.stream_data = { ...response.payload };
          this.handles = response.payload.handles
          this.hashtags = response.payload.hashtags


      }
  })
  }

  processNewFeeds(pageId){
    this.facebookService.fetchOrganizationPagePosts(pageId).subscribe(
        (response: any) => {
            
          const { status_code, success, payload } = response;
          if (success && (status_code == 200 || status_code == 201)) {

            this.feedItems = payload
          }
        },
        (e) => {
        this.toaster.error("Cannot find latest feed for your page.");
      }
    );
  }
  
  onDropdownChange(event: any): void {
    this.selectedOption = event.target.value;
  }
}
